module.exports = __webpack_public_path__ + "img/Color-picker.35ba6028.png";